function countdown_(elementName, minutes, seconds) {
        var element = document.getElementById(elementName);
        var totalSeconds = minutes * 60 + seconds;
        var endTime;
        var remainingTime = localStorage.getItem('remainingTime');
        if (remainingTime) {
            endTime = (+new Date) + parseInt(remainingTime);
        } else {
            endTime = (+new Date) + totalSeconds * 1000;
        }  
        function updateTimer() {
            var msLeft = endTime - (+new Date);
            if (msLeft < 1000) {
                // element.innerHTML = "Time is up!";
                $(".upcart_announcement").hide();
                localStorage.removeItem('remainingTime'); 
            } else {
                $(".upcart_announcement").show();
                var time = new Date(msLeft);
                var hours = time.getUTCHours();
                var mins = time.getUTCMinutes();
                var seconds = time.getUTCSeconds();
                element.innerHTML = (hours ? hours + ':' + twoDigits(mins) : mins) + ':' + twoDigits(seconds);
                localStorage.setItem('remainingTime', msLeft);
                setTimeout(updateTimer, 1000);
            }
        }
        function twoDigits(n) {
            return (n <= 9 ? "0" + n : n);
        }
        updateTimer();
    }
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      // alert("ok");
       event.preventDefault();
       const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      //  mandasa custom js 
      // alert("quantity change");
       $(this).parents('.cart-item_').addClass("loadingCart");
       setTimeout(() => {  
             cartItems.updateQuantity(this.dataset.index, 0);
        }, 200);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
 
 
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        let drawerScrollPosition = $('cart-drawer .main_container_').scrollTop();
       
        
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          
        });
      // $('cart-drawer .main_container_').addClass('updating');
      
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
           var body = document.body;
           // $(".dark-mode .toggle__input").prop('checked', true);
          // Check local storage on page load
        var darkMode_ = localStorage.getItem('darkMode');
var checkbox_ = $('#mode-toggle');

// Set dark mode based on local storage
if (darkMode_ === 'enabled') {
    checkbox_.prop('checked', true);
    document.body.classList.add('dark-mode');
} else {
    checkbox_.prop('checked', false);
    document.body.classList.remove('dark-mode');
}

// Variables for shipping bar and values
let container_ = document.querySelector(".shipping-cont");
if (container_) {
    let shippingValue = container_.querySelector(".free-shipping-val");
    let shippingBar = container_.querySelector("#free-shipping-bar");

    if (shippingValue && shippingBar) {
        let minimum_free_shipping = Number(shippingValue.dataset.initialvalue);
        let customValue = minimum_free_shipping;

        // Function to update the shipping bar and message
        function setInitialShippingbarValue() {
            let cart_total = Number(shippingValue.dataset.total);
            let shipping_msg = shippingValue.dataset.shippingmsg;
            let freeshipmsg = shippingValue.dataset.freeship;
            let currencysymbol = shippingValue.dataset.symbol;
            let shipping_value = minimum_free_shipping * 100;
            let shipping_value_left = shipping_value - cart_total;
            let shipping_percentage_fraction = (cart_total * 100) / shipping_value;

            if (shipping_value_left > 0) {
                let shippingletvalue = (shipping_value_left / 100).toFixed(2);
                let shipmsg = shipping_msg.replace("[SHIPPINGVALUE]", currencysymbol + shippingletvalue);
                shippingBar.style.width = `${shipping_percentage_fraction}%`;
                shippingValue.innerHTML = shipmsg;
            } else {
                shippingValue.innerHTML = freeshipmsg;
                shippingBar.style.width = "100%";
            }
        }

        // Observe changes in the `shippingValue` attributes
        new MutationObserver((mutations) => {
            let updatedValue = Number(shippingValue.dataset.initialvalue);
            if (updatedValue !== customValue) {
                customValue = updatedValue;
                setInitialShippingbarValue();
            }
        }).observe(shippingValue, { attributes: true });

        // Initialize the shipping bar
        setInitialShippingbarValue();
    } else {
        console.warn("Shipping bar or value element is missing.");
    }
} else {
    console.warn("Shipping container element is missing.");
}
    countdown("ten-countdown", timer_length, 0);
         
  $('cart-drawer .main_container_').scrollTop(drawerScrollPosition);
      // setTimeout(() => {
      //      $('cart-drawer .main_container_').removeClass('updating');
      //  }, 100)
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
